import { makeStyles } from '@material-ui/core/styles';
import Button, { ButtonProps } from '@material-ui/core/Button';
import React from 'react';
import Typography from '@material-ui/core/Typography';

import Icon from '@material-ui/core/Icon';
const useStyles = makeStyles(theme => ({
    button: (props: any) => ({
        background: props.bgColor,
        color: props.textColor || theme.palette.primary.main,
        margin: theme.spacing(1),
    }),
    icon: {
        marginRight: theme.spacing(1),
    },
}));

interface ISimpleButton extends ButtonProps {
    label?: string;
    bgColor?: string;
    textColor?: string;
    action?: any;
    icon?: string;
    children?: any;
    disabled?: boolean;
}
const SimpleButton = ({ action, bgColor, disabled = false, icon, label, textColor, variant }: ISimpleButton) => {
    const classes = useStyles({
        bgColor: bgColor,
        textColor,
    });
    return (
        <Button
            className={classes.button}
            component="span"
            disabled={disabled}
            onClick={() => (action ? action() : undefined)}
            variant={variant ? variant : 'contained'}
        >
            {icon && <Icon classes={{ root: classes.icon }}>{icon}</Icon>}
            <Typography display="block" variant="button">
                {label}
            </Typography>
        </Button>
    );
};

export default SimpleButton;
